import React, { Component } from "react";
import { withStyles } from '@mui/styles';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Collapse
} from "@mui/material";
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel'
import Input from '@mui/material/Input' 
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio' 
import MenuItem from '@mui/material/MenuItem';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import InboxIcon from "@mui/icons-material/Inbox";
import Button from '@mui/material/Button';
import ErrorDialog from './ErrorDialog'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';

import {APIGetPresenterSlides, APIMergeFiles,APIGetJSONMappings, APIGetpdf } from './Api'
import apiConfig from './config/api'
import { Document, Page, pdfjs } from 'react-pdf';
import FullPagePDFViewer from './FullPagePDFViewer'
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
import pdf_config from './configs/pdf_configs'
import {Alerts4} from './Alerts'

// The following lines live together to get Access to the PDFPages class
import {PDFPages} from './classes/PDFPages'



var  json 
var pdf_pages 
var presenterslides = [];
var useabledeck = []; 

const dt = new Date()
const init_create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`

const console_log = (text) => { 
  return  // Comment out if yoy want logging
  console_log(text)
}
const ColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
    backgroundColor: '#ff3099',
    '&:hover': {
      backgroundColor: '#ff3099',
    },
  },
}))(Button);

const SmallColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', 
    backgroundColor: '#04c659',
    '&:hover': {
      backgroundColor: '#04a659',
    },
    fontSize: '10px',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginLeft: '5px',
    marginRight: '5px'
  },
}))(Button);

const getItems = async (saletype) => {
  
  if(!presenterslides || typeof presenterslides === "undefined"  ) return null

    return  await Promise.all(presenterslides.map(async (p) => {
      //console.log(p)
      return {
        saletype,
        slide_id: p.slide_id,
        slide_no: p.slide_no,
        type: p.type,
        id: `slide-${p.slide_order}`,
        primary: `Slide # ${p.slide_no} (${p.slide_id})`,
        secondary: p.description,
        phone_mandatory: p.mandatory,
        field_mandatory: p.mandatory_field,
        mandatory: (
          (p.mandatory  === "Y" && p.type=="PHONE" && saletype === "PHONE" ) || 
          (p.mandatory_field === "Y" && p.type=="FIELD" && saletype === "FIELD" ) ) || 
          (p.type === "BOTH" &&  
            (
              (p.mandatory_field === "Y" && saletype === "FIELD" ) || 
              (p.mandatory === "Y" && saletype === "PHONE" )
            )  
          ) ? true : false,

        selected: (
          (p.mandatory === "Y" && p.type=="PHONE" && saletype === "PHONE") || 
          (p.mandatory_field === "Y" && p.type=="FIELD" && saletype === "FIELD" ) ) || 
          (p.type === "BOTH" && 
            (
              (p.mandatory_field==="Y" && saletype === "FIELD") || 
              (p.mandatory==="Y" &&  saletype === "PHONE")
            )
        ) ? true: false,
        finance: p.finance,
        batteryonly: p.batteryonly,
        mailmerge: p.mailmerge,
        pdf_file:  p.page,          //p.pdf_file, //'page' + p.slide_id + ".pdf",
        slide_order: p.slide_order,
        path: p.path,
        url: p.url
    }}
  ))
}


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: "rgb(235,235,235)"
  })
});

const getListStyle = isDraggingOver => ({
  //background: isDraggingOver ? 'lightblue' : 'lightgrey',

});

const checkProps =(prop) => {
  return typeof prop !== "undefined" && prop ? true : false
}
class SlideSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
        origprops: props,
        saletype: props.saletype,
        items: props.slides,
        pdfpreview: '/live/templates/pdf/',
        pdfpage: 'page1.pdf',
        pageNumber: 1,
        numPages: 1,
        pdffile: '',
        slide_no: '',
        slide_id: '',
        pdf_file_path: '',
        is_loading: false,
        preview_file: '',
        show_preview: false,
        preview_page: 1,
        confirmPreview: false,
        show_alert: false,
        alert_severity: 'info',
        alert_text: '',
        ismounted: false,
        saletype: props.saletype,
        presentation_versions: props.presentation_versions ? props.presentation_versions : [{id: `${props.flg_id}.pdf`, description: 'Default System Proposal', current_decktype: 'mnd', create_dt: init_create_dt}],
        current_decktype: 'mnd',
        selected_presentation: checkProps(props.selected_presentation) ? props.selected_presentation : `${props.flg_id}.pdf`,
        copied: false,
        versionDescription: '',
        description_error: '',
        btnaddversion: false,
        allowcopy: false,
        create_dt: null,
        slidesloading: false
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

 
  componentDidMount = async () => {
      //console.clear()
    try {
      this.setState({slidesloading: true})
      const dt = new Date()
      const create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`
      
      console_log("#### SlideSetup Component Did Mount ####")
      await this.setUpAPIS()
      const saletype = this.props.saletype
      await this.updateFromProps(saletype)
      //console_log("Offerid " + this.props.offerid + ", " + this.props.offertype)
      if(this.state.presentation_versions.length ==0 )
      {
        let versions = []
        versions.push({id: `${this.props.flg_id}.pdf`, description: 'Default System Proposal', current_decktype: 'mnd', create_dt: init_create_dt})
        this.setState({presentation_versions: versions, create_dt, slidesloading: false})
      }
    }catch(ex) {
      console.log("Error Mounting component")
      console.log(ex)
      this.setState({slidesloading: false})
    }
 

  }

  updateFromProps = async (saletype) => {
    var items = null

    if(this.props.slides && this.props.slides !== null && typeof this.props.slides !== "undefined" && this.props.slides.length > 0 && this.props.slides[0].saletype == this.props.saletype) {
        //console_log("Using Original Slides")
        items = this.props.slides
        this.setState({items, ismounted: true})
    }else {
      //console_log("Getting New Slides")
      var i = 0
      items = await getItems(saletype)
      useabledeck = JSON.parse(JSON.stringify(items))
      this.setState({items,ismounted: true, slidesloading: false})
      this.props.onChange(items, this.state.presentation_versions, this.state.selected_presentation)
    }
  }

  setUpAPIS = async () => {
    presenterslides = await APIGetPresenterSlides(this.props.flg_id)
    json = await APIGetJSONMappings()
    pdf_pages = new PDFPages(json)
  }

  static getDerivedStateFromProps = async (nextProps, prevState) => {

    //console_log("getDerivedStateFromProps")
    //console_log(nextProps)
    //console_log("----------")
    //console_log(prevState)
    // do things with nextProps.someProp and prevState.cachedSomeProp
    if(nextProps.saletype != prevState.origprops.saletype) {
      //console_log("Sale Type Has Changed...")
      await this.updateFromProps(nextProps.saletype)
    }
    if((prevState.origprops!== nextProps) ) {
      console_log("Props changed")
        return {
          origprops: nextProps,
          slides: nextProps.slides,
          saletype: nextProps.saletype
        }
    }
    return null
  }

  handleSelectionChange = (slide_no, mandatory) => event => {
    console.log(`slide_no ${slide_no} mandatory ${mandatory} checked ${event.target.checked}`)
      if(mandatory) return
      let slides = this.state.items
      let slide = this.state.items.find(x => x.slide_no === slide_no)
      slide.selected = event.target.checked
      this.props.onChange(slides, this.state.presentation_versions, this.state.selected_presentation)
      this.setState({items: slides})
  }

  SetPage =  async (url, page,path, slide_id, slide_no) => {
    // const file = path + '/' + page
    const flg_id = this.props.flg_id
    const file = url + '/' + page
    //console_log(file)
    this.setState({is_loading: true})
    var pdf = file // await APIGetpdf(file)
    pdf = `${apiConfig.baseUrl}/api/pdf/preview/${flg_id}/${encodeURIComponent(page)}`
    //public_url
    this.setState({pdfpage: page,pdf_file_path: file, pdffile: pdf, slide_no, slide_id, is_loading: true  })

  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );
    this.props.onChange(items, this.state.presentation_versions, this.state.selected_presentation)

    this.setState({
      items
    });
  }
  onDocumentLoadSuccessPages = ({numPages}) => {
    //console_log("onDocumentLoadSuccessPages")
    //console_log(numPages)

    if(typeof numPages !== "undefined" )
      this.setState({is_loading: false,num_pages: numPages, numPages})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }
  onDocumentLoadSuccess = (event) => {

    if(typeof event !== "undefined" && typeof event.target !== "undefined")
      this.setState({is_loading: false,num_pages: event, numPages: event})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }

  // Filter to see if this slide should show up in the deck or not
  itemsfilter = (item) => {
    //console_log("Slide: " + item.slide_id)
    try {
      const page = pdf_pages.getOnePage(item.slide_id)
      const offertype = this.props.offerid
      //if(typeof page !== "undefined" && typeof page.filter !== "undefined")
      //  console_log("itemsfileter: " + item.slide_id + ": " + offertype + ", " + page.filter + ", " + page.filter.length)
      //else  
      //  console_log(item)

      if(item.type === 'BOTH' || item.type === this.state.saletype) {
        if(!pdf_pages.hasFilter(item.slide_id))
          return true
        else if(typeof page !== "undefined" && typeof page.filter !== "undefined" && page && offertype && offertype.substr(0,page.filter.length) === page.filter ) 
          return true
        else
          return false 
      }
      else  
        return false
    }catch(err) {
      console_log(err)
        return false
    }
  }

  LoadFullDeck = async () => {
    this.setState({slidesloading: true},async () =>  this.FullDeck())

  }

  FullDeck = async () => {
    try {
      let items = []
      let fd = []
      const ni = useabledeck.length;

      for(let i=0; i<ni; i++) {
        fd.push(JSON.parse(JSON.stringify(useabledeck[i])))
        const item = fd[i]
        item.selected = true
      }
      this.setState({slides: fd, current_decktype: 'fld', items: fd, slidesloading: false}, () =>
      this.props.onChange(fd, this.state.presentation_versions, this.state.selected_presentation))
    }catch(e) {
      console.error('An Error Occured Loading the FullDeck')
      console.error(e)
      this.setState({slidesloading: false})
    }
  }

  LoadMandatoryDeck = async () => {
    this.setState({slidesloading: true},async () =>  this.MandatoryDeck())
  }

  MandatoryDeck = async  () => {
    this.setState({slidesloading: true})
    //let slides = this.state.items
    //const md = slides.map(item => {
    let items = []
    let md = []
    const ni = useabledeck.length;
    for(let i=0; i<ni; i++) {
      md.push(JSON.parse(JSON.stringify(useabledeck[i])))
      const item = md[i]
      item.selected = item.mandatory==true ? true : false
    }


    this.setState({slides: md, current_decktype: 'mnd', items: md, slidesloading: false}, () =>
    this.props.onChange(md, this.state.presentation_versions, this.state.selected_presentation))
  }

  LoadFinanceDeck = async () => {
    this.setState({slidesloading: true},async () =>  this.FinanceDeck())
  }
  FinanceDeck = async () => {
    this.setState({slidesloading: true})
    let items = []
    const ni = useabledeck.length;
    let md = []
    for(let i=0; i<ni; i++) {
      md.push(JSON.parse(JSON.stringify(useabledeck[i])))
      const item = md[i]
      item.selected = item.finance ? true : false
      item.mandatory = item.finance ? true : false
    }

    this.setState({slides: md,current_decktype: 'fnd', items: md, slidesloading: false}, () =>
    this.props.onChange(md, this.state.presentation_versions, this.state.selected_presentation))
  }

  LoadCustomDeck = async () => {
    this.setState({slidesloading: true},async () =>  this.CustomDeck())
  }
  CustomDeck = async ()  => {
    this.setState({slidesloading: true})  
    let items = []
    let cd = []
    const ni = useabledeck.length;
    for(let i=0; i<ni; i++) {
    cd.push(JSON.parse(JSON.stringify(useabledeck[i])))
    const item = cd[i]
    if(item.slide_no == 1) {
        item.selected =  true
        item.mandatory = true

      }else {
        item.selected =  false
        item.mandatory = false
      }
    }


    this.setState({slides: cd,current_decktype: 'cdk', items: cd, slidesloading: false}, () =>
    this.props.onChange(cd, this.state.presentation_versions, this.state.selected_presentation))
  }

  LoadBatteryDeck = async () => {
    this.setState({slidesloading: true},async () =>  this.BatteryDeck())
  }
  BatteryDeck = async () => {
    this.setState({slidesloading: true}) 
    let items = []
    let bd = [];
    const ni = useabledeck.length;
    for(let i=0; i<ni; i++) {
      bd.push(JSON.parse(JSON.stringify(useabledeck[i])))
      const item = bd[i];
      item.selected = item.batteryonly ? true : false
      item.mandatory = item.batteryonly ? true : false
    }


    this.setState({slides: bd,current_decktype: 'bat', items: bd, slidesloading: false}, () =>
    this.props.onChange(bd, this.state.presentation_versions, this.state.selected_presentation) )
  }

  selectDeck = () => {
    switch(this.state.current_decktype) {
      case "fld":
        this.LoadFullDeck()   // FullDeck()
        break
      case "mnd":
          this.LoadMandatoryDeck()
          break
      case "fnd":
        this.LoadFinanceDeck()
        break
      case "bat":
        this.LoadBatteryDeck()
        break
      case "cdk":
        this.LoadCustomDeck()
        break
    }
  }

  DoMerge = async () => {

    // Calculations must be run before you can Merge the presentation.
    if(!this.props.calculations_run) {
      this.setState({show_alert: true, alert_severity: 'error', alert_text: "You cannot create the presentation until you have Calculated Savings. Click the 'Calculate Savings' Button!"}) 
      return 
    }
    const flg_id = this.props.flg_id
    const items = this.state.items
    const files = items.filter(this.itemsfilter).filter(item => {return(item.selected)}).map(item => {
      return ({slide_id:item.slide_id, pdf_file: item.pdf_file})
    })

    const final_files = files.map(item => {
        var new_item = JSON.parse(JSON.stringify(item))
        if(pdf_pages.hasTemplate(item.slide_id)) {
          const page = pdf_pages.getTemplate(item.slide_id)
          new_item.template = page.template
        }
        return new_item
    })
    console_log("Calling APIMergeFiles with " + final_files)
    //console.log(this.state.selected_presentation)
    await APIMergeFiles(this.props.flg_id, final_files, this.state.selected_presentation)
    console_log("APIMergeFiles Completed!!")
    this.setState({merge_pres: false,show_alert: true, alert_severity: 'info', 
    alert_text: "The Presentation Slides have now been merged and you may View the Presentation"}) 


  }


  DoOpenPres = async () => {
    const flg_id = this.props.flg_id
    var output =  pdf_config.dir_path + '/' + flg_id + '/pdf/' + flg_id + '.pdf'
    //var output =  '/presenter/documents/customers/' + flg_id + '/pdf/' + flg_id + '.pdf'
    console_log("Get PDF " + output)
    var preview = await APIGetpdf(output)
    preview = `${apiConfig.baseUrl}/api/pdf/presentation/${flg_id}`
    this.setState({preview_file: preview, show_preview: true,confirmPreview: this.state.preview_page > 1 ? true: false,})
  } 

  handlePreview = (events ) => {
    if(events)
      this.setState({confirmPreview: false})
    else
      this.setState({confirmPreview: false, preview_page: 1})
  }  

  AddVersion = (id) => {
    if(id == "") return;
    let versions = [...this.state.presentation_versions]
    const dt = new Date()
    const create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`
    if(this.state.versionDescription == "") {
      this.setState({description_error:'This field must be completed', btnaddversion: false})
      return;
    }
    for(let i=0; i< versions.length; i++) if(versions.id == id) return;
    versions.push({id, description: this.state.versionDescription, current_decktype: this.state.current_decktype, create_dt })
    this.setState({presentation_versions: versions, btnaddversion: false,versionDescription: '', 
    selected_presentation: id, allowcopy: true}, () => {this.props.onChange(this.state.items, versions, this.state.selected_presentation, create_dt)})
    
  }
 
  updateversionDescription = (event) => {
    let val = event.target.value
    this.setState({versionDescription:val,btnaddversion:val>""?true:false,description_error: val>""?"":"This field must be completed",copied:false})
  }

  CreateVersionText = () => {
    const {current_decktype} = this.state
    const {flg_id} = this.props
    var dt = new Date()
    var code = `${flg_id}_${dt.getFullYear()}${dt.getMonth()+1}${dt.getDate()}${dt.getHours()}${dt.getMinutes()}${dt.getSeconds()}${dt.getMilliseconds()}${this.state.current_decktype}.pdf`
    return code;
  }
  ClosePreview = () => { 
    this.setState({show_preview: false})
  }
  updatePage = (page) => {
    this.setState({preview_page: page})
  }

  changePage = (offset) => {
    this.setState({pageNumber: this.state.pageNumber + offset})
  }

 previousPage = () => {
    this.changePage(-1);
  }

  nextPage = () => {
    this.changePage(1);
  }

  updateSelectedVersion = (event) => {
    //console.log("updateSelectedVersion")
    let pver= [...this.state.presentation_versions]
    let current_decktype = this.state.current_decktype
    const dt = new Date()
    let create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`
    //console.log(pver)
    for(let i=0; i<pver.length; i++) {
      if(pver[i].id == event.target.value) {
        //console.log(`matched presentation_versions current_decktype is ${current_decktype} selected decktype is ${pver[i].current_decktype}`)
          // Matched now either set or update Slide Deck Type
          if(typeof pver[i].current_decktype == "undefined")
              pver[i].current_decktype = current_decktype
          else  
            current_decktype = pver[i].current_decktype

        //console.log(`dectype of selected element is now ${pver[i].current_decktype}`)
          if(typeof pver[i].create_dt !== "undefined" && pver[i].create_dt )
            create_dt = pver[i].create_dt
          else  
            pver[i].create_dt = create_dt
          break;
      }
    }

    this.setState({allowcopy: true, selected_presentation: event.target.value, copied: false, 
      current_decktype, presentation_versions: pver, create_dt},() => {this.selectDeck()})
  }

  getDeckType = () => {
    var decktype = "Unknown"
    switch(this.state.current_decktype) {
        case "fld":
          decktype = "Full";
          break;
        case 'mnd':
          decktype = "Mandatory";
          break;
        case 'fnd':
          decktype = "Finance";
          break;
        case 'cdk':
          decktype = "Custom";
          break;
    }
    return decktype;
  }
  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    const url =this.state.pdfpreview + '/' + this.state.pdfpage
    //const pdffile = this.state.pdffile
    //const slide_no = this.state.slide_no
    const { classes } = this.props;
    const ismounted = this.state.ismounted
    const { pdffile, slide_no, pageNumber, numPages } = this.state
    var  items = this.state.items 
    const new_version = this.CreateVersionText()
    const decktype = this.getDeckType()

    if( this.state.confirmPreview ) {
      return (
        <Alerts4
        open={this.state.confirmPreview} onClose={this.handlePreview } preview_page = {this.state.preview_page}
        />
      )
    }
    if(this.state.show_preview) {
      return (<>
      <Backdrop className={classes.fullscreen} open={this.state.show_preview} >
          <FullPagePDFViewer file={this.state.preview_file} preview_page={this.state.preview_page} onChange={this.updatePage} ClosePreview={this.ClosePreview} />
      </Backdrop>
      </>
      )
    }
    return (
      <>
      <div className={classes.mainDiv} style={{display: 'inline-block', textAlign: 'start'}}>
        <div  style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'flex-start', alignItems: 'center', textAlign: 'left' }}  >
          <div style={{textAlign: 'left', fontSize: '12px', display: 'inline-block'}} >
          <FormControl component="fieldset">  
            <RadioGroup row aria-label="position" name="position" value={this.state.current_decktype} >
            <FormControlLabel
              className={classes.radioItems}
              value="fld"
              control={<Radio color="primary"  onClick={() => {this.LoadFullDeck() }} />}
              label={<span style={{fontSize: '12px'}} >Full Deck</span>}
              labelPlacement="top"
            />
            <FormControlLabel
              className={classes.radioItems}
              value="mnd"
              control={<Radio color="primary"  onClick={() => {this.LoadMandatoryDeck()}} />}
              label={<span style={{fontSize: '12px'}} >Mandatory Deck</span>}
              labelPlacement="top"
            />
            <FormControlLabel
              className={classes.radioItems}
              value="fnd"
              control={<Radio color="primary" className={classes.radioItems}  onClick={() => {this.LoadFinanceDeck()}} />}
              label={<span style={{fontSize: '12px'}} >Finance Deck</span>}
              labelPlacement="top"
            />
            <FormControlLabel
              className={classes.radioItems}
              value="bat"
              control={<Radio color="primary" className={classes.radioItems}  onClick={() => {this.LoadBatteryDeck()}} />}
              label={<span style={{fontSize: '12px'}} >Battery Install Deck</span>}
              labelPlacement="top"
            />
            <FormControlLabel
              className={classes.radioItems}
              value="cdk"
              control={<Radio color="primary" className={classes.radioItems}  onClick={() => {this.LoadCustomDeck()}} />}
              label={<span style={{fontSize: '12px'}} >Custom Deck</span>}
              labelPlacement="top"
            />
          </RadioGroup>
          </FormControl><br/>
            Created At: {this.state.create_dt}
          </div>
        <div style={{display: 'inline'}} >
        <ColorButton onClick={() => {this.DoMerge()} }  >Merge Presentation</ColorButton>&nbsp;
        <ColorButton onClick={() => {this.DoOpenPres()} }  >Open</ColorButton><br/>
        </div>
      </div><br/>
      <div id="containter" style={{  display: 'flex', flexFlow: 'row wrap', justifyContent: 'flex-start', alignItems: 'center', textAlign: 'left' }} >
        <div style={{textAlign: 'left', justifyContent:'flex-start'}} >
          Either Select Current Saved Versions<br/>
          <Select
            className={classes.version_input}
            value={this.state.selected_presentation}
            onChange={this.updateSelectedVersion} >
            {this.state.presentation_versions.map((item,index) => { return ( <MenuItem key={index} value={item.id}  >{`${item.description}`} </MenuItem> )})}
          </Select><br/>
          <span style={{fontSize: '10px'}}>NB: "Merge Presentations" Will save as {this.state.selected_presentation}</span>
        </div>
        <div style={{textAlign: 'left', alignItems: 'center', border: '1px solid grey', borderRadius: '5px', marginLeft: '10px', padding: '5 5 5 5', verticalAlign: 'middle'}}  >
            <FormControl error >
                <InputLabel id="lblVerDesc" className={classes.version_descriptions} >Or Add A New Version</InputLabel>
                <Input labelid="lblVerDesc" 
                        className={classes.version_input}
                        value={this.state.versionDescription} 
                        onChange={this.updateversionDescription} 
                        aria-describedby="component-error-text" />
                <FormHelperText id="component-error-text">{this.state.description_error}</FormHelperText>
            </FormControl>                  
            <SmallColorButton disabled={!this.state.btnaddversion} onClick={() => {this.AddVersion(new_version)} }  >Add Presentation Version</SmallColorButton>
        </div>
      </div><br/>   
      <Collapse in={this.state.show_alert}> 
        <Alert
          variant='outlined'
          style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
          severity={this.state.alert_severity}          
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                this.setState({show_alert: false})
              }}
            >
            <CloseIcon fontSize="inherit" />
            </IconButton > } >
              {this.state.alert_text}
        </Alert>
      </Collapse>   
      <div>
      {this.state.slidesloading && 1==2 &&
      <Backdrop className={classes.backdrop} open={this.state.slidesloading} >
        <CircularProgress color="secondary" size={150}/>
      </Backdrop>
      }
      {items !== null && 
      <div style={{overflow: 'auto', height: '600px', width: '450px', margin_bottom: '10px', left: 0, position: 'absolute'}} >
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
              <List ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                {items && 
                  items.filter(this.itemsfilter).map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <ListItem
                       
                        divider={true}
                        ContainerComponent="li"
                        ContainerProps={{ ref: provided.innerRef }}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <ListItemIcon >
                          <InboxIcon onClick={(event) => this.SetPage(item.url,item.pdf_file,item.path,item.slide_id,item.slide_no,event)}/>
                        </ListItemIcon>
                        <ListItemText
                          primary={item.primary}
                          secondary={item.secondary}
                        />
                        <ListItemSecondaryAction>
                           <FormControlLabel
                                value={true}
                                control={<Checkbox  color={item.mandatory ? "primary" : "secondary" } size="small"  checked={item.selected} onChange={this.handleSelectionChange(item.slide_no, item.mandatory)} /> } 
                                label={<Typography  style={{fontSize: 12}} >Show</Typography>}
                                labelPlacement="end"
                                
                            />
                        </ListItemSecondaryAction>
                      </ListItem>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
          )}
        </Droppable>
      </DragDropContext>
      </div>} <br/>
      <div style={{marginLeft: '460px'}}>
        <Backdrop className={classes.backdrop} open={this.state.is_loading} >
            <CircularProgress color="secondary" size={150}/>
        </Backdrop>
        <div style={{fontSize: '20pt'}} >Slide {slide_no}</div>
        <Document
          loading="Please wait whilst the slide loads..."
          file={pdffile}
          onLoadError={this.onDocumentLoadSuccess}
          onLoadSuccess={this.onDocumentLoadSuccessPages}
        >
        <Page pageNumber={pageNumber} 
          scale={0.5}
          loading="Please wait whilst the slide loads..."
          className={classes.document}
          onRenderSuccess={this.onDocumentLoadSuccess}
          onLoadError={this.onDocumentLoadSuccess}
        />
        </Document> 
        <div>
          <p>PAGE {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}</p>
          <button type="button" disabled={pageNumber <= 1} onClick={this.previousPage}>Previous</button>
          <button
            type="button"
            disabled={pageNumber >= numPages}
            onClick={this.nextPage}
          >Next</button>
        </div>
      </div>
      </div>
      </div>
      </>
    );
  }
}

const styles = theme => ({
  document: {
    position: 'absolute',
    border: '1px solid #ff3099',
  },
  backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1000,
      width: '100%',
      height: '100%'
  },
  buttonspace: {
    marginRight: '10px'
  },
  fullscreen: {
    backgroundColor: "#fff",
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  version_descriptions: {
    fontSize: '12px',
    width: '50%',
    maxWidth: '450px',
  },
  version_input: {
    fontSize: '12px',
    width: '250px',
    maxWidth: '250px',
  },
  versionBox: {
    width: '80%', 
    maxWidth: '500px',
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginTop: '5px',
    display: "flex",
    alignItems: "center"
  },
  mainDiv: {
    position: 'relative', 
    height: '600px', 
    width: '1280px ',
  },
  radioItems: {
    fontSize: '12px'
  }
});

export default withStyles(styles)(SlideSetup)
